import React, { useState } from 'react';
import { StyleSheet, View, Image, TouchableOpacity } from 'react-native';
import { withNamespaces } from 'react-i18next';
import { Grid, Col } from 'react-native-easy-grid';
import { useHistory } from 'react-router-dom';

import {
  FONT_SIZE_HEADER,
  COLOR_TEXT_DEFAULT,
  FONT_SIZE_DEFAULT,
  BG_HOVER,
  BORDER_TABLE_GREY,
  TEXT_COLOR_GREEN,
} from '@assets/style/styleDefault';
import ModalAlert from '../Modals/ModalAlert';
import { JText as Text } from '../common/JText';
import ModalBack from '../Modals/ModalBack';

const HeaderToken = ({
  isDirty,
  linkBtnBack,
  textBtnBack,
  linkIcon,
  textHeader,
  codeToken,
  nameToken,
  scope1,
  scope2,
  scopeThreeDot,
  widthIconTitle,
  heightIconTitle,
  t,
}) => {
  const [hover, setHover] = useState(false);
  const [menuScopeThreeDot, setMenuScopeThreeDot] = useState(false);
  const [isModalBack, setIsModalBack] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const history = useHistory();
  const openModalBack = () => {
    if (isDirty) {
      setIsModalBack(true);
    } else {
      history.goBack();
    }
  };

  const handleModalBack = () => {
    setIsModalBack(false);
    setIsModal(true);
  };

  const onHover = (e) => {
    e.preventDefault();
    setHover(true);
  };

  const onHoverOver = (e) => {
    e.preventDefault();
    setHover(false);
  };

  return (
    <View style={styles.wrapperHeader}>
      <Grid style={styles.headerToken}>
        <Col size={scopeThreeDot ? 7 : 5} style={styles.flexRow}>
          <TouchableOpacity style={[styles.flexRow, styles.cursorPointer]} onPress={() => openModalBack()}>
            <Image style={styles.buttonBack} source={require(`../../assets/icons/${linkBtnBack}`)} />
            <Text style={styles.textBack}>{textBtnBack}</Text>
          </TouchableOpacity>
          <Image
            style={[
              styles.iconHeader,
              widthIconTitle && { width: widthIconTitle },
              heightIconTitle && { height: heightIconTitle },
            ]}
            source={require(`../../assets/icons/${linkIcon}`)}
          />
          <Text style={styles.textHeader}>{textHeader}</Text>
          {codeToken && <Text style={styles.codeToken}>{codeToken}</Text>}
          {nameToken && <Text style={styles.nameToken}>{nameToken}</Text>}
        </Col>
        {scopeThreeDot ? (
          <Col size={5} style={[styles.flexRow, { justifyContent: 'flex-end' }]}>
            <Col size={3} style={styles.spacing_btn}>
              {scope1}
            </Col>
            <Col size={3} style={styles.spacing_btn}>
              {scope2}
            </Col>
            <Col
              size={1}
              onMouseEnter={(e) => onHover(e)}
              onMouseLeave={(e) => onHoverOver(e)}
              style={[styles.spacing_btn, { position: 'relative' }]}
            >
              <View
                onClick={() => setMenuScopeThreeDot(!menuScopeThreeDot)}
                style={[
                  styles.menuScopeThreeDot,
                  {
                    backgroundColor: hover ? '#2e2d2d' : '',
                  },
                ]}
              >
                {scopeThreeDot}
              </View>
            </Col>
          </Col>
        ) : (
          <Col size={4} style={[styles.flexRow, styles.spaceBetween]}>
            {scope1 && <View style={styles.spacing_btn}>{scope1}</View>}
            {scope2 && <View style={styles.spacing_btn}>{scope2}</View>}
          </Col>
        )}
      </Grid>
      {/* <ModalAlert
        isModalVisible={modalAlert}
        setModalVisible={setModalAlert}
        icon="exclamationIcon.svg"
        iconWidth={6}
        iconHeight={23}
        modalText="ライセンスが不足しています。契約 内容をご確認 ください"
      /> */}

      <ModalAlert
        isModalVisible={isModal}
        setModalVisible={setIsModal}
        modalText={t('components_Headers_HeaderToken.modalAlertText')}
        iconWidth={16}
        iconHeight={12.5}
        icon="successGreen.svg"
        // linkPage="tokens"
      />
      <ModalBack
        isModal={isModalBack}
        setIsModal={setIsModalBack}
        otherModal={handleModalBack}
        linkPage="/file-manager/other-notifications"
      />
    </View>
  );
};

export default withNamespaces()(HeaderToken);

const styles = StyleSheet.create({
  cursorPointer: {
    cursor: 'pointer',
  },
  flexRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  wrapperHeader: {
    height: 80,
    zIndex: 3,
  },
  headerToken: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonBack: {
    height: 15,
    width: 15,
  },
  textBack: {
    fontSize: FONT_SIZE_DEFAULT,
    color: TEXT_COLOR_GREEN,
    marginLeft: 10,
    marginRight: '2rem',
    fontWeight: 'bold',
  },
  iconHeader: {
    height: 24,
    width: 24,
  },
  textHeader: {
    fontSize: FONT_SIZE_HEADER,
    color: COLOR_TEXT_DEFAULT,
    marginLeft: 10,
    fontWeight: 'bold',
  },
  codeToken: {
    marginLeft: '2rem',
    color: COLOR_TEXT_DEFAULT,
    fontSize: FONT_SIZE_HEADER,
    fontWeight: 'bold',
  },
  nameToken: {
    marginLeft: '1rem',
    color: COLOR_TEXT_DEFAULT,
    fontSize: FONT_SIZE_HEADER,
  },
  spacing_btn: {
    marginRight: 5,
    marginLeft: 5,
  },
  menuScopeThreeDot: {
    zIndex: 10,
    borderRadius: 50,
    width: 40,
    height: 40,
    marginHorizontal: 10,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    fontSize: FONT_SIZE_DEFAULT,
    color: 'white',
    padding: 10,
    paddingLeft: 20,
  },
  menuScopeThreeDotContent: {
    borderRadius: 8,
    position: 'absolute',
    top: -5,
    right: -2,
    paddingVertical: 10,
    display: 'none',
    width: 280,
    backgroundColor: '#2e2d2d',
  },
  //modal change language
  wrapperModal: {
    maxWidth: 900,
    minWidth: 600,
  },
  mainClose: {
    maxWidth: 200,
    marginRight: 'auto',
    paddingLeft: 20,
  },
  contentClose: {
    with: 20,
    height: 40,
    backgroundColor: 'transparent',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  iconClose: {
    width: 15,
    height: 15,
    marginRight: 10,
  },
  maxWidth700: {
    backgroundColor: '#fff',
    borderRadius: 10,
    padding: 30,
  },

  warperItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 550,
    borderBottomColor: BORDER_TABLE_GREY,
    borderBottomWidth: 1,
    paddingVertical: 15,
    paddingLeft: 10,
  },

  iconLanguage: {
    width: 26,
    height: 18,
    marginRight: 15,
  },
  itemHovered: {
    backgroundColor: BG_HOVER,
  },
  spaceBetween: {
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
});
